import React, {Component} from 'react';
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import SecondServer from '../database/SecondServer'
import EZNotify from '../Alert/SimplerNotify';
import GrantRequest from '../Grants/RequestDialog';
import SitePerms, {grantRequired} from './SitePerms'
import DeviceHealthData from './DeviceHealthData';
import {fetchSiteDevices} from '../database/fetch'
import { isDCAPRadio, isRepeaterRadio } from '../Report/Model/DeviceType';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { UTCTimeAgo } from '../timeFunctions/timeFns';
import 'react-circular-progressbar/dist/styles.css';

import './devicehealth.css';

export default class DeviceHealthPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mdts: 0,
      rptrs: 0,
      connected: null,
      advancing: null,
      rptrCount: null,
      banner: null,
      bannerStyle: "warning",
      grantModal: false,
    }
    this.ss = null;
    this.unmount = false
    this.nav = this.nav.bind(this)
  }

  componentWillUnmount() {
    this.unmount = true
    if (this.ss)
      this.ss.cancel();
  }

  async componentDidMount() {
    const site = this.props.getActiveSite()
    const perms = site?.perms ?? await SitePerms (this.props)
    if (perms && grantRequired(perms)) { 
      this.setState ({grantModal: true})
      return;
    }
    this.ss = new SecondServer(this.props);
    const target = await fetchSiteDevices(siteAccessCode(site), this.props)
    const deref = target?.jsonResponse?.data?.data?.targetDevices
    if (deref) {
      await this.getCurrentData(deref)
     }
    else if (false === this.unmount) {
      if (site.site_details.mdt_cnt > 0) 
        this.setState ({banner: "We can't get details for this site", bannerStyle: 'warning'})
      else 
        this.setState ({banner: "No devices are set up. Please use the Configuration tab to Add Devices", bannerStyle: 'primary'})
    }
  }
  async componentDidUpdate(prevProps,prevState) {
    if (prevProps.forceUpd !== this.props.forceUpd) {
      const site = this.props.getActiveSite()
      const target = await fetchSiteDevices(siteAccessCode(site), this.props)
      const deref = target?.jsonResponse?.data?.data?.targetDevices
      this.getCurrentData(deref)
    }
  }
  async getCurrentData(deref) {
    const rptrs = deref.filter(r=>isRepeaterRadio(r, 'device_id'))
    const rptrCount = rptrs.length
    const advRptrCount = rptrs.reduce((total, r) => 
      total+(1&&(UTCTimeAgo(r?.LatestData?.RXTime) < 86400000)), 0)
    const dcapCount = deref.reduce((total, x) => total+isDCAPRadio(x, "device_id"), 0)
    const endrange = new Date(); 
    const startrange = new Date(endrange.getTime() - 24*3600 * 1000)
    this.healthData = new DeviceHealthData(this.props);
    const health = await this.healthData.getHealthofThese(startrange, endrange, deref, "device_id");
    if (this.unmount === false) {
      if (health.notAvailable === false) {
        this.setState ({connected: health.connected, advancing: health.advancing, 
          mdts: deref.length -(rptrCount+dcapCount), rptrs: rptrCount, 
          advRepeaters: advRptrCount})
      }
      else
        this.setState({mdts: deref.length -(rptrCount+dcapCount), rptrs: rptrCount,})
    }
  }
  gradient (num, denom) {
    const total = Math.min((denom >0 ? (num / denom) * 100 : 0), 100)
    return {'--size':'220px', '--stop1': (total*0.3)+"%", '--stop2':total+"%"}
  }

  singleHealth(max, count, position) {
    if (null !== count) {
      const title = <div className='mdt-title-in-circular-progress'>{Math.min(count, max)+'/'+Math.max(count, max)}</div>
      return this.singleGuage(max, count, title, position, 'nonadv')
    }
    return <div className={position+" working"}>&nbsp;</div>
  }
  mdtBreakout (total, position) {
    const connected = Math.min(this.state?.connected, total)
    const title = <div className='mdt-title-in-circular-progress'>MDTs</div>
    return this.tripleGauge(total, connected, title, position, 'mdt')
  }
  rptrBreakout (total, position) {
    const connected = Math.min(this.state?.advRepeaters, total)
    const title = <div className='rptr-title-in-circular-progress'>Repeaters</div>
    return this.tripleGauge(total, connected, title, position, 'rptr')
  }
  nav(evt) {
    let element = evt.target
    while (!element?.id && element?.parentElement) 
      element = element?.parentElement
    if (this.props?.nav_click) this.props.nav_click(element?.id)
  }
  singleGuage(max, count, title, position, id){
    const percentage = (count / max) * 100
    return (
        <div style={{ width: 220, height: 220, "marginBottom": "1em"}}>
          <CircularProgressbarWithChildren value={percentage}
            styles={buildStyles({
              textColor: "red",
              pathColor: "#18BC9c",
              trailColor: "#FF2C55"
            })}
          >
            <div className={position+" circle-click" } id={id} onClick={this.nav}>
              <div> {title} </div>
            </div>
          </CircularProgressbarWithChildren>
        </div>
    )
  }
  tripleGauge (total, connected, title, position, id) {
    const dispConn = isNaN(connected) ? 0 : connected
    const absent = total - dispConn
    const percentage = (connected / total) * 100
    return (
      <div style={{ width: 220, height: 220, "marginBottom": "1em"}}>
        <CircularProgressbarWithChildren value={percentage}
          styles={buildStyles({
            textColor: "red",
            pathColor: "#18BC9c",
            trailColor: "#FF2C55"
          })}
        >
          <div className={position+" circle-click" } id={id} onClick={this.nav}>
            <div>
              {title}
              <div className='mdt-info'>{total}
                <span className='mdt-label'> Commissioned</span></div>
              <div className='mdt-info'><span className='mdt-green'>{dispConn}</span>
                <span className='mdt-label'> Checking In</span></div>
              <div className='mdt-info'><span className='mdt-red'>{absent}</span>
                <span className='mdt-label'> Not Reporting</span></div>
            </div>
          </div>
        </CircularProgressbarWithChildren>
      </div>
    )
  }
  grantModal(onOff) {
    this.setState({grantModal: onOff})
  }
  renderCaption(style, text) {
    return (
      <span className={style}>
        <span className='caption'>{text}<br/></span>
        <span className='caption-time'>Last 24 hours</span>
      </span>
    )
  }
  render () {
    //const site = this.props.getActiveSite();
    //const mdt = Number(site?.site_details?.mdt_cnt ?? 0) + Number(site?.site_details?.pmt_cnt ?? 0)
    //const rptr = Number(site?.site_details?.rptr_cnt ?? 0)
    //const divRptr = Number(site?.site_details?.divRptr_cnt ?? 0)
    const divRptr = 0
    const mdt = this.state.mdts
    const rptr = this.state.rptrs
    return <div className="device-health">
      {this.state.banner !== null ? 
        <EZNotify message={this.state.banner} styleName={this.state.bannerStyle} container="alert-top" /> : null}
      <GrantRequest {...this.props} show={this.state.grantModal} hide={()=>this.grantModal(false)} />

      <div className="health-items">
        {this.mdtBreakout(mdt, 'health-col1')}
        <span className="health-col1-caption caption">
          <span className='caption'>Transceivers<br/></span>
          <span className='caption-time'>Last 24 hours</span>
        </span>
        {this.singleHealth(mdt, this.state.advancing, "health-col2")}
        {this.renderCaption ("health-col2-caption caption", "Advancing")}
        {this.rptrBreakout(rptr+divRptr, "health-col3")}
        {this.renderCaption("health-col3-caption caption", "Repeaters")}
      </div>
    </div>
  }
}


